import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { useDispatch, useSelector } from "react-redux";

import { setSections } from "../../redux/booking/booking-slice";
import { cn } from "../../utils/lib";

export default function OrderTabs() {
  const dispatch = useDispatch();

  const {
    totalBookingCount,
    upcomingBookingLength,
    jobsForTodayLength,
    jobsForTomorrowLength,
  } = useSelector((state) => state.booking);

  const tabs = React.useMemo(
    () => [
      {
        key: "all-bookings",
        label: "All Bookings",
        smallLabel: "All",
        count: totalBookingCount,
        callbackFn: () => {
          dispatch(
            setSections({
              allBooking: true,
              upcomingBooking: false,
              jobsForToday: false,
              jobsForTomorrow: false,
            }),
          );
        },
      },
      {
        key: "upcoming-bookings",
        label: "Upcoming Bookings",
        smallLabel: "Upcoming",
        count: upcomingBookingLength,
        callbackFn: () => {
          dispatch(
            setSections({
              allBooking: false,
              upcomingBooking: true,
              jobsForToday: false,
              jobsForTomorrow: false,
            }),
          );
        },
      },
      {
        key: "jobs-for-today",
        label: "Jobs for today",
        smallLabel: "Today",
        count: jobsForTodayLength,
        callbackFn: () => {
          dispatch(
            setSections({
              allBooking: false,
              upcomingBooking: false,
              jobsForToday: true,
              jobsForTomorrow: false,
            }),
          );
        },
      },
      {
        key: "jobs-for-tomorrow",
        label: "Jobs for tomorrow",
        smallLabel: "Tomorrow",
        count: jobsForTomorrowLength,
        callbackFn: () => {
          dispatch(
            setSections({
              allBooking: false,
              upcomingBooking: false,
              jobsForToday: false,
              jobsForTomorrow: true,
            }),
          );
        },
      },
    ],
    [
      totalBookingCount,
      upcomingBookingLength,
      jobsForTodayLength,
      jobsForTomorrowLength,
    ],
  );

  const [activeTab, setActiveTab] = React.useState(tabs[0].key);

  return (
    <div className="flex gap-x-4 pt-4 xl:gap-x-8">
      <AnimatePresence>
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => {
              setActiveTab(tab.key);
              tab.callbackFn();
            }}
          >
            <div className="flex cursor-pointer gap-x-2">
              <motion.span
                layout
                style={{ transformOrigin: "center" }}
                className={cn(
                  "text-[#C9CED6]",
                  tab.key === activeTab && "font-bold text-white",
                )}
              >
                <span className="max-xl:hidden">{tab.label}</span>
                <span className="xl:hidden">{tab.smallLabel}</span>
              </motion.span>
              <motion.span
                layout
                className={cn(
                  "min-w-6 rounded-[0.625rem] bg-[#181E29] px-1 py-[2px] text-center transition-colors duration-300",
                  "flex items-center justify-center",
                  "text-[0.625rem] text-white",
                  tab.key === activeTab && "bg-[#144EE3]",
                )}
              >
                {tab.count}
              </motion.span>
            </div>
            {activeTab === tab.key && (
              <motion.div
                className="mt-1.5 h-[2px] rounded-full bg-blue-500 shadow-blue-500"
                layoutId="underline"
              />
            )}
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
}
